import { PackageStatus } from '../../../modules/enums/status';
import { useAuth, useRequest } from '../../../modules/hooks';
import type { GuestPackageResponse, PackagesResponse } from '../../../modules/interfaces';
import { endpoints } from '../../../modules/mappers/urls';

export const useDeletePackage = (packageId: string) => {
  const { credentialsInfo } = useAuth()!;
  const deleteUrl = `${endpoints.PACKAGES}/${packageId}`;

  return useRequest<string>(
    deleteUrl,
    'delete',
    {
      authToken: credentialsInfo?.token,
    },
    { manual: true },
  );
};

export const useUpdatePackage = (packageId: string) => {
  const { credentialsInfo } = useAuth()!;

  const editUrl = `${endpoints.PACKAGES}/${packageId}`;

  return useRequest<string>(
    editUrl,
    'put',
    {
      authToken: credentialsInfo?.token,
    },
    { manual: true },
  );
};

export const useCreatePackage = (propertyId?: string) => {
  const { credentialsInfo } = useAuth()!;

  return useRequest<PackagesResponse>(
    endpoints.PACKAGES,
    'post',
    {
      authToken: credentialsInfo?.token,
      propertyId,
    },
    { manual: true },
  );
};

export const useGetAllPackages = (propertyId: string) => {
  const { credentialsInfo } = useAuth()!;

  return useRequest<PackagesResponse[]>(endpoints.PACKAGES, 'get', {
    authToken: credentialsInfo?.token,
    propertyId,
    params: { status: PackageStatus.ACTIVE },
  });
};

export const useUpdateReservationPackage = (guestPackageId?: string) => {
  const { credentialsInfo } = useAuth()!;

  const URL = `${endpoints.RESERVATION_PACKAGES}/${guestPackageId}`;
  return useRequest<GuestPackageResponse[]>(
    URL,
    'patch',
    {
      authToken: credentialsInfo?.token,
    },
    { manual: true },
  );
};
